import { useTextFont } from '@/hooks';
import { TextAttribute } from '@/services/shape/attributes/text';
import { ShapeUtils } from '@/services/shape/shape-util';

export const getTextConfig = async () => {
  const { fontIdList } = useTextFont();
  const textAttrs = new TextAttribute();
  // 获取默认的字体和字重
  const font = fontIdList.value?.[0];
  const fontId = font?.value ?? 'misans';
  const fontWeight = font?.weights?.[0]?.value ?? 'normal';
  const { width, height } =
    (await ShapeUtils.getActualSizeOfChars(textAttrs.text, {
      family: fontId + '-' + fontWeight,
      fontSize: textAttrs.fontSize
    })) ?? {};

  return { width, height, fontId, fontWeight };
};
